$(document).ready(function (e) {
    if ($('.c-page-accordion').length > 0) {
        $('.c-page-accordion__button').click(function () {
            const button = $(this);
            const chevron = $($(this)[0].lastElementChild);
            const panel = $(this).next();

            button.toggleClass('c-page-accordion__button--open')
            chevron.toggleClass('c-page-accordion__chevron--open')
            panel.toggleClass('c-page-accordion__panel--open')
        });
    }
});